<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.text_76')"
    icon="res-billdomain"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :res-id="data.id"
      :id="listId"
      :data="detailData"
      :on-manager="onManager"
      :show-group-actions="false"
      :show-single-actions="false"
      :getParams="getParams"
      :hiddenKindTabs="['domain', 'external_project']"
      :defaultDomainId="listRowData.domain_id"
      :defaultDate="date.dateParam"
      :defaultDateMode="date.dateMode"
      :defaultDataType="date.dateParam.data_type"
      :showBillShared="true"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import _ from 'lodash'
import Overview from '@Bill/views/overview/components'
import Projects from '@Bill/views/project/components/List'
import Actions from '@/components/PageList/Actions'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'ClouddomainSidePage',
  components: {
    Actions,
    Overview,
    Projects,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.budget_alert_type_cost'), key: 'overview' },
        { label: this.$t('bill.project'), key: 'projects' },
      ],
    }
  },
  computed: {
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'overview':
          return 'OverviewForCloudDomainSidePage'
        case 'projects':
          return 'ProjectListForCloudDomainSidePage'
        default:
          return ''
      }
    },
    getParams () {
      if (this.params.windowData.currentTab === 'projects') {
        return {
          filter: `domain_id.equals(${this.listRowData.domain_id})`,
        }
      }
      return {}
    },
    date () {
      const dateParam = _.get(this.params, 'options.dateParam') || {}
      const dateMode = _.get(this.params, 'options.dateMode') || 'month'
      return { dateParam, dateMode }
    },
  },
}
</script>
